module.exports = __webpack_public_path__ + "img/gal-13.0dee43f7.jpg";